<template>
    <div class="common_body" :class="{ 'mobile-style': $isMobileDevice }">
        <div class="common_title">{{ title }}</div>
        <div class="common_content">
            <div v-html="content"></div>
        </div>
    </div>
</template>
<script>
export default {
    props: {
        title: {
            type: String,
            default: ''
        },
        content: {
            type: String,
            default: ''
        }
    },
    data() {
        return {};
    }
};
</script>
<style lang="scss" scoped>
$max-width: 1200px;
.common_body {
    background-color: #ffffff;
    padding: 40px 0;
    .common_title {
        max-width: $max-width;
        margin: 0 auto;
        font-size: 40px;
        font-family: 'PingFang_Bold';
        font-weight: 600;
        color: #070707;
        margin-bottom: 40px;
    }
    .common_content {
        max-width: $max-width;
        margin: 0 auto;
    }
}
</style>
